import { HierarchyUserStatus } from "../../../constants/HierarchyUserStatus";
import { FaEnvelope } from "react-icons/fa";
import { useResendInviteLink } from "../../../utilities/mutations/useInsertTenantUserMutation";
import { makeToast } from "../../../utilities/appStore";
import { successToast, errorToast } from "../../../constants/toast";
import { useState } from "react";
import "./UserStatus.css"; // import shared styles

export default function UserStatus({ status, accountId }) {

    const { isPending, mutateAsync: resendInviteAsync, error } = useResendInviteLink(accountId);
    const onResendInvite = async () => {
        await resendInviteAsync({}, { onError: failedCall, onSuccess: successCall });
    }
    const successCall = () => {
        makeToast("User Invite Sent", successToast);
        setIsHovering(false);
    };
    const failedCall = () => {
        makeToast("Error Sending User Invite", errorToast);
        setIsHovering(false);
    };
    const [isHovering, setIsHovering] = useState(false);

    if (status === HierarchyUserStatus.Pending) {
        return (
            <>
                {!accountId && <span className="text-danger">Pending</span>}
                {accountId && (
                    <span className="d-flex align-items-center gap-1 text-danger">
                        Pending
                        {!isPending && <>
                            <span
                                style={{ cursor: "pointer" }}
                                onClick={() => onResendInvite(accountId)}
                            >
                                <div
                                    style={{ position: "relative", display: "inline-block" }}
                                    onMouseEnter={() => setIsHovering(true)}
                                    onMouseLeave={() => setIsHovering(false)}
                                >
                                    <FaEnvelope className="text-success" />
                                    <span className="text-success">&gt;</span>

                                    {isHovering && <span className="custom-tooltip">Resend Invite</span>}
                                </div>
                            </span>
                        </>}
                        {isPending && (
                            <div className="bg-white border rounded px-2 py-1 text-muted small ml-2">
                                Resending invitation...
                            </div>
                        )}

                    </span>

                )}
            </>
        );
    }

    if (status === HierarchyUserStatus.Assigned) {
        return <span className="text-success">Assigned</span>;
    }

    return <span>Unassigned</span>;
}
